import { Reducer } from 'redux'
import { createReducer } from 'reduxsauce'
import { AlertTypes, IAlertState } from './types'
import { IActionType, success, failure, request, IPaginator} from '../root.types'
import { Alert } from '../../application/models/alert/alert'

const INITIAL_STATE: IAlertState = {
    create: {
        alert: new Alert(),
        loading: false,
        success: false,
        error: false
    },
    list: {
        alerts: [],
        loading: false,
        error: false,
        success: false,
        paginator: {
            first: 0,
            rows: 10,
            page: 0,
            pageCount: 0,
            totalRecords: 0,
            search: {
                key: '',
                value: ''
            }
        }
    }
}

// reducers para carregar listagem dO ACOMPANHAMENTO
export const loadAlertRequest = (state: IAlertState = INITIAL_STATE,
    action: IActionType<{paginator: IPaginator }>) => {
    const { paginator } = action.payload

    return { ...state, list: request({ ...state.list, paginator }) }
}

export const loadAlertSuccess = (
    state: IAlertState = INITIAL_STATE,
    action: IActionType<{ data: Alert[], headers: any }>) => {
    const { data, headers } = action.payload

    const paginator = {
        ...state.list.paginator,
        totalRecords: parseInt(headers['x-total-count'], 10)
    }
    return {
        ...state,
        list: success({ ...state.list, alerts: data, paginator })
    }
}

export const loadAlertFailure = (state: IAlertState = INITIAL_STATE) => {
    return {
        ...state,
        list: failure(state.list)
    }
}


// reducers para procura paciente especifico
export const findAlertRequest = (state: IAlertState = INITIAL_STATE,
    action: IActionType<{ alertId: string }>) => {
    return { ...state, create: request({ ...state.create }) }
}
export const findAlertSuccess = (
    state: IAlertState = INITIAL_STATE,
    action: IActionType<{ data: Alert }>) => {
    const { data } = action.payload
    return {
        ...state,
        create: success({ ...state.create, alert: data })
    }
}

export const findAlertFailure = (state: IAlertState = INITIAL_STATE) => {
    return {
        ...state,
        create: failure(state.create)
    }
}


// reducers para atualizar dados do paciente 
export const updateAlertRequest = (state: IAlertState = INITIAL_STATE, action: IActionType<{ alert: Alert }>) => {
    return { ...state, create: request({ ...state.create }) }
}

export const updateAlertSuccess = (state: IAlertState = INITIAL_STATE,
    action: IActionType<{ data: Alert }>) => {
    const { data } = action.payload
    const updadedList = state.list.alerts.map((alert) =>
        alert.id === data.id ? data : alert
    )
    return {
        ...state,
        create: success({ ...state.create, alert: data }),
        list: { ...state.list, alerts: updadedList }
    }
}

export const updateAlertFailure = (state: IAlertState = INITIAL_STATE) => {
    return {
        ...state,
        create: failure(state.create)
    }
}


const reducer: Reducer<IAlertState> = createReducer<IAlertState>(INITIAL_STATE, {
    [AlertTypes.LOAD_ALERT_REQUEST]: loadAlertRequest,
    [AlertTypes.LOAD_ALERT_SUCCESS]: loadAlertSuccess,
    [AlertTypes.LOAD_ALERT_FAILURE]: loadAlertFailure,    
    [AlertTypes.FIND_ALERT_REQUEST]: findAlertRequest,
    [AlertTypes.FIND_ALERT_SUCCESS]: findAlertSuccess,
    [AlertTypes.FIND_ALERT_FAILURE]: findAlertFailure,  
    [AlertTypes.UPDATE_ALERT_REQUEST]: updateAlertRequest,
    [AlertTypes.UPDATE_ALERT_SUCCESS]: updateAlertSuccess,
    [AlertTypes.UPDATE_ALERT_FAILURE]: updateAlertFailure,  
})
export default reducer    